<template>
	<div v-loading="dataLoading">
		<template v-if="formData">
			<tab name="8">{{id}} {{formData.activityName}} <b v-if="formData && formData.haveEditAudit"
					class="color-danger">存在还未处理的演出修改审核，请处理后再编辑演出信息</b></tab>
			<el-form :model="formData" :rules="rules" ref="formData" label-position="top"
				:disabled="formData && formData.haveEditAudit">
				<el-row :gutter="30">					
					<el-col :span="12">
						<el-form-item prop="approval" label="报批进度:">
							<el-select v-model="formData.approval" size="medium" placeholder="请选择">
								<el-option :value="1" label="已有批文"></el-option>
								<el-option :value="2" label="报批申请中"></el-option>
								<el-option :value="3" label="还未申请报批"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item prop="approvalsSn"
							:rules="[{required: formData.approval == 1 ? true : false, message: '请输入批文编号'}]"
							:show-message="formData.approval == 1 ? true : false">
							<span slot="label">批文编号: </span>
							<el-input v-model="formData.approvalsSn" placeholder="请输入批文编号" size="medium"
								maxlength="40"></el-input>
						</el-form-item>
						<el-form-item prop="approvalsPassTime"
							:rules="[{required: formData.approval == 1 ? true : false, message: '请输入报批通过日期'}]"
							:show-message="formData.approval == 1 ? true : false">
							<span slot="label">报批通过日期: </span>
							<el-date-picker v-model="formData.approvalsPassTime" type="datetime" placeholder="请输入报批通过日期"
								value-format="yyyy-MM-dd HH:mm:ss" size="medium"></el-date-picker>
						</el-form-item>
						<el-form-item prop="approvalsUserNum"
							:rules="[{required: formData.approval == 1 ? true : false, message: '请填写报批人数'}]"
							:show-message="formData.approval == 1 ? true : false">
							<span slot="label">报批人数: </span>
							<el-input-number style="width:100%" v-model="formData.approvalsUserNum"
								placeholder="请填写报批人数" size="medium" :min="0" :max="999999" :precision="0"
								:controls="false"></el-input-number>
						</el-form-item>
						<el-form-item v-if="formData.approval == 1" prop="isReport" label="演出是否上报采集平台:">
							<el-radio-group v-model="formData.isReport" size="medium"
								:disabled="formData.firstReportTime ? true : false">
								<el-radio :label="1">是</el-radio>
								<el-radio :label="0">否</el-radio>
							</el-radio-group>
						</el-form-item>
						<div v-if="formData.firstReportTime" class="MT20">
							<el-alert type="warning" :closable="false"> 演出&售票订单 已于 {{formData.firstReportTime}}
								开始上报文旅部演出采集系统</el-alert>
						</div>
						<!-- <el-form-item prop="isShowQualification" label="证照信息展示:">
						    <el-radio-group v-model="formData.isShowQualification" size="medium" >
						        <el-radio :label="1">是</el-radio>
						        <el-radio :label="0">否</el-radio>
						    </el-radio-group>
						</el-form-item>
						<el-form-item  prop="approvalManageId" label="报批方:" v-if="formData.isShowQualification == 1">							
							<el-select
							    v-model="formData.approvalManageId" 
							    filterable 
							    remote
							    placeholder="请输入报批方名称"
							    :remote-method="searchApproval"
							    :loading="approvalLoading"
							    size="medium">
							    <el-option
							        v-for="item in approvalList"
							        :key="item.id"
							        :label="item.name"
							        :value="item.id">
							    </el-option>
							</el-select>
						</el-form-item> -->

					</el-col>
					<el-col :span="12">
						<el-form-item label="演出批文:">
							<image-upload 
								:url.sync="approvals1" 
								:urlFull.sync="approvals1"
								accept="image/png, image/jpeg, application/pdf" >
								<span slot="type">支持格式为JPG、PNG、PDF</span>
								<span slot="size">不限制尺寸</span>
							</image-upload>
							<div class="MT20">
								<image-upload 
								:url.sync="approvals2" 
								:urlFull.sync="approvals2" 
								accept="image/png, image/jpeg, application/pdf">
								<span slot="type">支持格式为JPG、PNG、PDF</span>
								<span slot="size">不限制尺寸</span>
								</image-upload>
							</div>
						</el-form-item>
						<el-form-item v-if="formData.hostList">
							<span slot="label" class="color-danger">演出主办: <small
									class="font10">(请注意核实批文中的举办单位跟演出主办对应的企业名称是否一致)</small></span>
							<div v-for="item in formData.hostList" :key="item.id">
								{{item.userId}}[{{$userType.get(item.userType)}}]{{item.userName}}
								<span v-if="item.claimType == 1 && item.headName"> (负责人姓名:{{item.headName}})</span>
								<span v-if="item.claimType == 2 && item.companyName"> (企业名称:{{item.companyName}})</span>
								<small v-if="item.status != 2" class="color-danger">(还未通过认证)</small>
							</div>
						</el-form-item>
						<el-form-item v-if="formData.approvalsAgentCompany">
							<span slot="label">代为报批公司:</span>
							<div>
								{{formData.approvalsAgentCompany}}
							</div>
						</el-form-item>					
					</el-col>
				</el-row>
				<el-row :gutter="30">
					<el-col :span="24">
						<el-form-item prop="isShowQualification" label="证照信息展示:">
							<el-radio-group v-model="formData.isShowQualification" size="medium">
								<el-radio :label="1">是</el-radio>
								<el-radio :label="0">否</el-radio>
							</el-radio-group>
						</el-form-item>
					</el-col>
					<el-card v-if="formData.isShowQualification == 1" class="ML10" style="width: 80%;">
						<el-row :gutter="0">
							<el-form-item>
								<span slot="label">从B类用户读取信息 </span>								
								<el-select
								    v-model="userId" 
								    filterable 
								    remote
								    placeholder="请输入B类用户名称"
								    :remote-method="searchUser"
								    :loading="userLoading"
								    size="medium"
                                    @change="getUserInfo">
								    <el-option
								        v-for="item in userList"
								        :key="item.id"
								        :label="`[${$userType.get(item.userType)}]${item.name}[${item.id}]`"
								        :value="item.id">
								    </el-option>
								</el-select>
								<!-- <el-button type="primary" size="small" @click="getUserInfo()" :loading="searchLoading">读取信息</el-button> -->
                                <div v-if="userId" class="MT10">
                                    <el-checkbox v-model="overwrite" :true-label="1" :false-label="0">是否覆盖B类用户认证信息</el-checkbox>
                                </div>
							</el-form-item>
						</el-row>
						<template>
							<el-form :model="approvalBaseVO" :rules="rules" ref="approvalBaseVO" label-position="top" size="medium">
								<el-row :gutter="0">
									<el-form-item prop="companyName" :rules="[{required: true, message: '请填写营业执照上的企业名称'}]">
										<span slot="label">企业名称 </span>
										<el-input v-model="approvalBaseVO.companyName" placeholder="请填写企业名称" size="medium"
											maxlength="100"></el-input>
									</el-form-item>
								</el-row>
								<el-row :gutter="0">
									<el-form-item prop="licenseId" :rules="[{required: true, message: '请填写营业执照上的统一社会信用代码'}]">
										<span slot="label">统一社会信用代码 </span>
										<el-input v-model="approvalBaseVO.licenseId" placeholder="请填写统一社会信用代码" size="medium"
											maxlength="100"></el-input>
									</el-form-item>
								</el-row>
								<el-row :gutter="0">
									<el-form-item prop="businessType" label="企业类型"
										:rules="[{required: true, message: '请选择企业类型'}]">
										<el-select v-model="approvalBaseVO.businessType" placeholder="请选择企业类型" size="small">
											<el-option :value="0" label="有限责任公司（自然人投资或控股）"></el-option>
											<el-option :value="1" label="股份有限公司"></el-option>
										</el-select>
									</el-form-item>
								</el-row>
								<el-row :gutter="0">
									<el-form-item prop="corporationName" label="法人代表姓名"
										:rules="[{required: true, message: '请填写法人代表姓名'}]">
										<el-input v-model="approvalBaseVO.corporationName" placeholder="请填写法人代表姓名" size="medium"
											maxlength="20"></el-input>
									</el-form-item>
								</el-row>
								<el-row :gutter="0">
									<el-form-item prop="registeredAddress" :rules="[{required: true, message: '请填写注册地址'}]"
										label="注册地址">
										<el-input v-model="approvalBaseVO.registeredAddress" placeholder="请填写注册地址" size="medium"
											maxlength="50"></el-input>
									</el-form-item>
								</el-row>
								<el-row :gutter="0">
									<el-form-item prop="registeredCapitalStr" label="注册资本"
										:rules="[{required: true, message: '请填写注册资本'}]">
										<el-input-number v-model="approvalBaseVO.registeredCapitalStr" :precision="2"
											controls-position="right" :min="0" :max="100000" size="medium" placeholder="请填写注册资本"
											style="width: 90%;"></el-input-number> 万元
									</el-form-item>
								</el-row>
							</el-form>
						</template>
					</el-card>
				</el-row>
			</el-form>
			<el-divider></el-divider>
			<div>
				<el-button @click="goBack">返回</el-button>
				<el-button v-if="$utils.have('/activity/saveApproval')" type="primary" @click="onSubmit"
					:disabled="formData && formData.haveEditAudit"  :loading="btnLoading">确认提交</el-button>
			</div>
		</template>
	</div>
</template>

<script>
	import Tab from './components/tab'
	import ImageUpload from '@/components/ImageUpload';
	import {fetchUser} from '@/assets/js/commonApi';
	export default {
		props: {
			id: {
				type: [Number, String],
				default: () => null
			},
			
		},
		components: {
			Tab,
			ImageUpload
		},
		data() {
			return {
				formData: null,
				dataLoading: false,
				searchLoading:false,
				btnLoading: false,
				userLoading:false,
				rules: {
					approval: [{
						required: true,
						message: "请选择报批进度"
					}]
				},
				redirect: this.$route.query.redirect,
				approvals1: '',
				approvals2: '',
				approvalList: [],
				approvalLoading: false,
				userId:'',
                overwrite: 0,
				userList:[],
				approvalBaseVO:{
					companyName:'',
					licenseId:'',
					businessType:0,
					corporationName:'',
					registeredAddress:'',
					registeredCapitalStr:''					
				},
			}
		},
		created() {
			if (this.id) {
				this.getDataDetail();
			}
		},
		methods: {
			//返回
			goBack() {
				if (this.redirect) {
					this.$router.push({
						path: this.redirect,
					});
				} else {
					this.$router.go(-1);
				}
			},
			//获取详情
			getDataDetail() {
				this.dataLoading = true;
				this.$request({
						url: "/activity/approval",
						params: {
							activityId: parseInt(this.id)
						},
						method: "post",
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if (state == 1) {
							this.formData = {
								...result,
								approval: result.approval && result.approval != 0 ? result.approval : '',
								isReport: result.isReport,
								// isReport: result.approval && result.approval != 1 ? 1 : result.isReport   1：已有批文 2：已递交报批手续 3:还未递交报批手续（暂无批文）
								approvalsUserNum: result.approvalsUserNum || undefined,
								isShowQualification: result.isShowQualification,
								//approvalBaseVO:result.approvalBaseVO || []
							}
							if (this.formData.approvals) {
								var approvals = this.formData.approvals.split(',')
								if (approvals.length > 0 && approvals[0]) {
									this.approvals1 = approvals[0]
								}
								if (approvals.length > 0 && approvals[1]) {
									this.approvals2 = approvals[1]
								}
							}
							if (result.applicantInfo) {
								var _arr = []
								_arr.push(result.applicantInfo);
								this.approvalList = _arr
							}
							if( result.approvalBaseVO ){
								this.approvalBaseVO = result.approvalBaseVO 
							}
							
							
						} else {
							this.$message.error(msg || "获取演出报批失败,请重试");
						}
					})
					.catch(() => {
						this.$message.error("获取演出报批失败,请重试");
					})
					.finally(() => {
						this.dataLoading = false;
					});
			},

			// 搜索用户
			async searchUser(query){
				if(query !== ""){
					this.userLoading = true;
					const res = await fetchUser({
						queryValue:query,
						userType:-1,
					}).finally(() => {
						this.userLoading = false;
					});
					
					const { state, result } = res.data;
					
					if (state == 1 && result) {
						this.userList = result;
					}
				}
			},
			getUserInfo(){
				if( this.userId == '' ){
					return this.$message.error("请先检索B类用户！");
				}
				this.searchLoading = true;
				this.$request({
						url: "/userClaim/detailByUserId",
						params: {
							userId: parseInt(this.userId)
						},
						method: "post",
					})
					.then((res) => {
						const {
							state,
							msg,
							result
						} = res.data;
						if ( state == 1 ) {							
							this.approvalBaseVO.companyName = result?.companyName || ''
							this.approvalBaseVO.licenseId = result?.licenseId || ''
							this.approvalBaseVO.businessType = result?.businessType
							this.approvalBaseVO.corporationName = result?.corporationName || ''
							this.approvalBaseVO.registeredAddress = result?.registeredAddress || ''
							this.approvalBaseVO.registeredCapitalStr = result?.registeredCapitalStr || 0.00
							
						} else {
							this.$message.error(msg || "暂未匹配到信息，请手动填写");
                            this.userId = ''
                            this.overwrite = 0
						}
					})
					.catch(() => {
						this.$message.error("获取演出报批失败,请重试");
                        this.userId = ''
                        this.overwrite = 0
					})
					.finally(() => {
						this.searchLoading = false;
					});
			},
			//表单提交
			onSubmit() {
				var approvals = ''
				if (this.approvals1 != '' && this.approvals2 != '') {
					approvals = this.approvals1 + "," + this.approvals2
				} else if (this.approvals1 == '') {
					approvals = this.approvals2
				} else if (this.approvals2 == '') {
					approvals = this.approvals1
				} else {
					approvals = ''
				}
				this.formData.approvals = approvals
				
				
				if ( this.formData.isShowQualification == 1 ) {
					
					if( !this.approvalBaseVO.companyName || this.approvalBaseVO.companyName == '' ){
						return this.$message.error("企业名称不能为空");
					}
					if( !this.approvalBaseVO.licenseId  ||  this.approvalBaseVO.licenseId =='' ){
						return this.$message.error("统一社会信用代码不能为空");
					}
					if( !this.approvalBaseVO.corporationName  ||  this.approvalBaseVO.corporationName =='' ){
						return this.$message.error("法人代表姓名不能为空");
					}
					if( !this.approvalBaseVO.registeredAddress  ||  this.approvalBaseVO.registeredAddress =='' ){
						return this.$message.error("注册地址不能为空");
					}
					
					
				}
				let  _formData = {
                    ...this.formData,
					approvalBaseVO: this.approvalBaseVO
                }
                if( this.overwrite == 1 ){
                    _formData.userId = this.userId
                }
				this.$refs["formData"].validate((valid) => {
					if (valid) {
						this.$request({
								url: "/activity/saveApproval",
								method: "POST",								
								data: {
								    ..._formData
								},
							})
							.then((res) => {
								//处理成功回调
								const {
									state,
									msg
								} = res.data;
								if (state && state == 1) {
									// this.$message.success("操作成功");
									this.$confirm('操作成功', '提示', {
										type: 'success',
										center: true,
										confirmButtonText: '返回上一页',
										cancelButtonText: '留在当前页面',
										closeOnClickModal: false
									}).then(() => {
										this.goBack();
									}).catch(() => {
										window.location.reload()
									})
								} else {
									return this.$message.error(msg || "操作失败");
								}
							})

					}
				});
			}
		}
	}
</script>
<style lang="scss" scoped>
	.font10 {
		font-size: 10px;
	}
</style>